import { useParams } from 'react-router-dom'
import {
  FilterReportTypeSchema,
  QCReportType,
  TimepointEFormReportType,
  GeneralReportType,
  ECRFReportType,
  ReportSchema,
} from '@common/config/api/client'
import useGetReports from './useGetReports'
import useDownloadReport, { ReportDownloadType } from './useDownloadReport'

export default function useReportActions(reportType: FilterReportTypeSchema) {
  const { studyId } = useParams()
  const { data, isLoading } = useGetReports(studyId!, reportType)
  const downloadMutation = useDownloadReport()

  const handleDownload = (report: ReportSchema) => {
    let downloadType: ReportDownloadType
    switch (report.report_type) {
      case 'QC':
        downloadType = { type: 'QC', reportType: report.report_subtype as QCReportType }
        break
      case 'TIMEPOINT_EFORM':
        downloadType = { type: 'TIMEPOINT_EFORM', reportType: report.report_subtype as TimepointEFormReportType }
        break
      case 'GENERAL':
        downloadType = { type: 'GENERAL', reportType: report.report_subtype as GeneralReportType }
        break
      case 'ECRF':
        downloadType = {
          type: 'ECRF',
          reportType: report.report_subtype as ECRFReportType,
          reportName: report.name,
          readTaskSubmissionId: report.context?.read_task_submission_id,
        }
        break
      default:
        downloadType = { type: 'TIMEPOINT_EFORM', reportType: report.report_subtype as TimepointEFormReportType }
        break
    }

    downloadMutation.mutate({
      studyId: studyId!,
      reportDownloadType: downloadType,
    })
  }

  return {
    reports: data?.reports ?? [],
    isLoading,
    handleDownload,
    isDownloading: downloadMutation.isPending,
  }
}
